<template>
    <card class="card-plain user-questionnaire">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div v-if="sliderQuestions || textQuestions" class="form-group">

                        <template v-for="question in sliderQuestions">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="col-form-label title-text"><b>{{ question.title | languageString }}</b></label>
                                    <label class="col-form-label">{{ question.text | languageString }}</label>
                                </div>
                                <div class="col-md-9">
                                    <opinion-slider v-model="answers[question._id]"
                                                    :min-label="question.minimumText | languageString"
                                                    :max-label="question.maximumText | languageString">
                                    </opinion-slider>
                                </div>
                            </div>
                            <hr>
                        </template>

                        <div class="row" v-for="question in textQuestions">
                            <div class="col-md-3">
                                <label class="col-form-label title-text"><b>{{ question.title | languageString }}</b></label>
                                <label class="col-form-label">{{ question.text | languageString }}</label>
                            </div>
                            <div class="col-sm-9">
                                <textarea v-model="answers[question._id]" class="form-control" placeholder="" rows="3"/>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 text-right">
                                <label class="col-form-label">{{$t('By saving this information you confirm that you are taking part in this query.')}}</label>
                            </div>
                            <div class="col-sm-12 text-right">
                                <p-button round native-type="submit" type="primary" @click="send" class="btn btn-fill btn-wd">{{$t('Save')}}</p-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </card>
</template>
<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import OpinionSlider from '@/components/Dashboard/Components/OpinionSlider'

  export default {
    components: {
      [OpinionSlider.name]: OpinionSlider
    },

    mounted () {
      this.initData()
    },
    computed: {
      ...mapState('user/queries', {
        answers: state => state.answers
      }),
      ...mapGetters({
        getById: 'user/queries/getById',
        getQuestionsByQueryId: 'user/queries/getQuestionsByQueryId'
      }),
      query: function () {
        return this.getById(this.$route.params.id)
      },
      sliderQuestions: function () {
        return this.getQuestionsByQueryId(this.$route.params.id).filter(q => q.type === 'slider')
      },
      textQuestions: function () {
        return this.getQuestionsByQueryId(this.$route.params.id).filter(q => q.type === 'text')
      },
      breadcrumb: function () {
        const breadcrumb = [
          { name: 'Queries', label: 'My Queries' }
        ]

        const { id } = this.$route.params
        if (id && this.query) {
          const label = this.$options.filters.languageString(this.query.title)
          breadcrumb.push({ name: 'QueryAnswer', params: { id }, label })
        }

        return breadcrumb
      }
    },
    methods: {
      ...mapActions('user/queries', ['getItem', 'updateItem', 'clearAnswers']),
      initData: function () {
        this.clearAnswers()
        this.getItem({ id: this.$route.params.id })
      },
      send: async function () {
        const id = this.$route.params.id
        const answers = this.getQuestionsByQueryId(this.$route.params.id).reduce((acc, q) => {
          acc.push({ question: q._id, type: q.type, answer: this.answers[q._id] })
          return acc
        }, [])
        const data = { answers, completed: true }
        try {
          await this.updateItem({ id, item: data })
          this.clearAnswers()
          this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })
          this.$router.push({ name: 'QueryResult', params: { id } })
        } catch (error) {
          this.$notify({ message: error.message, type: 'danger' })
        }
      }
    },
    watch: {
      '$route.params.id' () {
        this.initData()
      },
      breadcrumb () {
        this.$store.commit('breadcrumb/SET_ROUTE_DATA', {
          path: this.$route.path,
          breadcrumb: this.breadcrumb
        }, { root: true })
      }
    }
  }
</script>
<style lang="scss" scoped>
    .user-questionnaire {
        .form-group > .row {
            margin-bottom: 20px;
        }
    }

    .title-text {
        display: block;
    }
</style>
